<template>
  <slot v-if="vocabulary" />
  <div v-else-if="failed" class="relation-vocabulary-failed font-second">
    <p>The apparatus signs could not be loaded.</p>
    <button class="button is-small" @click="load">Try again</button>
  </div>
</template>

<script lang="ts">
import { defineComponent, provide, ref, shallowRef } from 'vue'
import { RelationVocabulary } from '@/hexapla-core/domains/lemmas/relation'
import { RELATION_VOCABULARY } from '@/compositions/functional/useRelationVocabulary'
import { useApiUrl } from '@/compositions/servicebuilder/useApiUrl'

/**
 * Loads the relation vocabulary once for a signed-in app (the portal, Labs) and
 * provides it to everything inside, which renders only once it has loaded: a
 * line printed before would lose its signs.
 */
export default defineComponent({
  name: 'RelationVocabularyGate',
  setup() {
    const vocabulary = shallowRef<RelationVocabulary | null>(null)
    const failed = ref(false)
    provide(RELATION_VOCABULARY, vocabulary)

    const load = () => {
      failed.value = false
      RelationVocabulary.load(useApiUrl())
        .then((loaded) => {
          vocabulary.value = loaded
        })
        .catch(() => {
          failed.value = true
        })
    }
    load()

    return { vocabulary, failed, load }
  },
})
</script>

<style lang="scss" scoped>
.relation-vocabulary-failed {
  padding: 2rem;
  text-align: center;
}
</style>
